import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sm:mt-32 lg:mt-36 mt-28 mb-16" }
const _hoisted_2 = { class: "flex flex-col items-center" }
const _hoisted_3 = {
  key: 0,
  class: "ms-4 mb-4 flex items-center mt-8"
}
const _hoisted_4 = { class: "flex justify-between container mt-2 mx-auto p-4" }
const _hoisted_5 = { class: "w-full flex flex-col bg-background dark:bg-backgroundDark border rounded-md border-secondary-400 dark:border-secondaryDark-grey pt-4 py-4 px-8" }
const _hoisted_6 = { class: "bg-primary-000 w-32 h-32 flex items-center justify-center mt-2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex justify-between container w-full p-4 flex-wrap" }
const _hoisted_10 = { class: "flex flex-col w-full md:flex flex-auto md:w-6/12 md:pe-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-500 text-base" }, "*", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-500 text-base" }, "*", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-500 text-base" }, "*", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-500 text-base" }, "*", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { id: "recaptcha-container" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "flex flex-col w-full md:flex flex-auto md:w-6/12 md:ps-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary-500 text-base" }, "*", -1)
const _hoisted_20 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ps_label_header_4 = _resolveComponent("ps-label-header-4")!
  const _component_ps_label = _resolveComponent("ps-label")!
  const _component_ps_route_link = _resolveComponent("ps-route-link")!
  const _component_ps_icon = _resolveComponent("ps-icon")!
  const _component_ps_label_title_3 = _resolveComponent("ps-label-title-3")!
  const _component_ps_input = _resolveComponent("ps-input")!
  const _component_ps_label_caption = _resolveComponent("ps-label-caption")!
  const _component_ps_checkbox_value = _resolveComponent("ps-checkbox-value")!
  const _component_ps_textarea = _resolveComponent("ps-textarea")!
  const _component_ps_button = _resolveComponent("ps-button")!
  const _component_ps_content_container = _resolveComponent("ps-content-container")!
  const _component_ps_loading_dialog = _resolveComponent("ps-loading-dialog")!
  const _component_user_phone_login_verification_modal = _resolveComponent("user-phone-login-verification-modal")!
  const _component_ps_error_dialog = _resolveComponent("ps-error-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ps_content_container, null, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ps_label_header_4, { class: "font-medium" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__edit_profile")), 1)
              ]),
              _: 1
            })
          ]),
          ($setup.userProvider.user?.data != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_ps_route_link, { to: { name: 'profile'} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ps_label, { class: "hover:underline cursor-pointer font-medium" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.userProvider.user.data ? $setup.userProvider.user.data.userName:''), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ps_icon, {
                  name: "rightArrow",
                  class: "mx-2"
                }),
                _createVNode(_component_ps_label, { class: "font-light" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__edit_profile")), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "p-4 mx-2 w-32 relative",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onImageClick && $setup.onImageClick(...args))),
                for: "upload-image1"
              }, [
                _createVNode(_component_ps_label_title_3, { class: "mt-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__profile_photo")), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("input", {
                  type: "file",
                  size: "1",
                  max: "1",
                  accept: ".jpg,.jpeg,.png",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.onImageSelected($event))),
                  ref: "image",
                  id: "upload-image1",
                  style: {"display":"none"},
                  ordering: 1
                }, null, 544),
                _createElementVNode("div", _hoisted_6, [
                  ($setup.previewImage.data == '')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        alt: "Placeholder",
                        width: "300px",
                        height: "300px",
                        class: "w-24 h-24 object-cover",
                        src: $setup.userProvider.imageUrl($setup.profilePhoto,2),
                        onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.userProvider.defaultProfileImage && $setup.userProvider.defaultProfileImage(...args)))
                      }, null, 40, _hoisted_7))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.previewImage.data, (image) => {
                        return (_openBlock(), _createElementBlock("img", {
                          key: image,
                          alt: "Placeholder",
                          width: "300px",
                          height: "300px",
                          class: "w-24 h-24 object-cover",
                          src: image,
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onImageClick && $setup.onImageClick(...args)))
                        }, null, 8, _hoisted_8))
                      }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ps_label, { class: "mt-1 mx-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__user_name")) + " ", 1),
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ps_input, {
                    class: "mt-2 mx-2",
                    type: "text",
                    placeholder: _ctx.$t('edit_profile__user_name'),
                    value: $setup.holder.userName,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($setup.holder.userName) = $event)),
                    onKeyup: _cache[5] || (_cache[5] = ($event: any) => ($setup.validateName($event)))
                  }, null, 8, ["placeholder", "value"]),
                  ($setup.userProvider.userResource.message != '')
                    ? (_openBlock(), _createBlock(_component_ps_label, {
                        key: 0,
                        class: "content-center px-4 py-4 rounded-md",
                        textColor: "text-primary-500 dark:text-primaryDark-accent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.userProvider.userResource.message), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ($setup.isValidUserName)
                    ? (_openBlock(), _createBlock(_component_ps_label_caption, {
                        key: 1,
                        class: "mt-2 mx-8",
                        textColor: "text-primary-500 dark:text-primaryDark-accent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("phone_login__user_name_required")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ps_label_caption, { class: "mt-2 mx-8" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("phone_login__user_name_format")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ps_label, { class: "mt-4 mx-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__email")), 1),
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ps_input, {
                    class: "mt-2 mx-2",
                    type: "text",
                    placeholder: _ctx.$t('edit_profile__email'),
                    value: $setup.holder.userEmail,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($setup.holder.userEmail) = $event))
                  }, null, 8, ["placeholder", "value"]),
                  _createVNode(_component_ps_label, { class: "mt-4 mx-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__phone")) + " ", 1),
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ps_input, {
                    class: "mt-2 mx-2",
                    type: "text",
                    placeholder: _ctx.$t('edit_profile__phone_placeholder'),
                    value: $setup.holder.userPhone,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($setup.holder.userPhone) = $event)),
                    onKeyup: _cache[8] || (_cache[8] = ($event: any) => ($setup.phoneNumber($event)))
                  }, null, 8, ["placeholder", "value"]),
                  ($setup.isValidPhone)
                    ? (_openBlock(), _createBlock(_component_ps_label_caption, {
                        key: 2,
                        class: "mt-2 mx-8",
                        textColor: "text-primary-500 dark:text-primaryDark-accent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("phone_login__phone_required")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ($setup.isValidPhoneFormat)
                    ? (_openBlock(), _createBlock(_component_ps_label_caption, {
                        key: 3,
                        class: "mt-2 mx-8",
                        textColor: "text-primary-500 dark:text-primaryDark-accent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("phone_login__phone_format")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ps_label, { class: "mt-4 mx-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__whatsapp")) + " ", 1),
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ps_input, {
                    class: "mt-2 mx-2",
                    type: "text",
                    placeholder: _ctx.$t('edit_profile__whatsapp_placeholder'),
                    value: $setup.holder.whatsapp,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (($setup.holder.whatsapp) = $event)),
                    onKeyup: _cache[10] || (_cache[10] = ($event: any) => ($setup.whatsapp($event)))
                  }, null, 8, ["placeholder", "value"]),
                  ($setup.isValidWhatsapp)
                    ? (_openBlock(), _createBlock(_component_ps_label_caption, {
                        key: 4,
                        class: "mt-2 mx-8",
                        textColor: "text-primary-500 dark:text-primaryDark-accent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("phone_login__whatsapp_required")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ($setup.isValidWhatsappFormat)
                    ? (_openBlock(), _createBlock(_component_ps_label_caption, {
                        key: 5,
                        class: "mt-2 mx-8",
                        textColor: "text-primary-500 dark:text-primaryDark-accent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("phone_login__whatsapp_format")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _createVNode(_component_ps_checkbox_value, {
                    title: _ctx.$t('edit_profile__show_emil_to_other_users'),
                    class: "mt-4 mx-2",
                    value: $setup.holder.isShowEmailBool,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (($setup.holder.isShowEmailBool) = $event))
                  }, null, 8, ["title", "value"]),
                  _createVNode(_component_ps_checkbox_value, {
                    title: _ctx.$t('edit_profile__show_phone_to_other_users'),
                    class: "mt-4 mx-2 mb-4",
                    value: $setup.holder.isShowPhoneBool,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (($setup.holder.isShowPhoneBool) = $event))
                  }, null, 8, ["title", "value"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_ps_label, { class: "mt1 mx-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__address")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ps_input, {
                    class: "mt-2 mx-2",
                    type: "text",
                    placeholder: _ctx.$t('edit_profile__address'),
                    value: $setup.holder.userAddress,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (($setup.holder.userAddress) = $event))
                  }, null, 8, ["placeholder", "value"]),
                  _createVNode(_component_ps_label, { class: "mt-4 mx-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__city")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ps_input, {
                    class: "mt-2 mx-2",
                    type: "text",
                    placeholder: _ctx.$t('edit_profile__city'),
                    value: $setup.holder.city,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (($setup.holder.city) = $event))
                  }, null, 8, ["placeholder", "value"]),
                  _createVNode(_component_ps_label, { class: "mt-4 mx-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__about_me")) + " ", 1),
                      _hoisted_19
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ps_textarea, {
                    class: "mt-2 mx-2",
                    type: "text",
                    placeholder: _ctx.$t('edit_profile__about_me'),
                    value: $setup.holder.userAboutMe,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (($setup.holder.userAboutMe) = $event))
                  }, null, 8, ["placeholder", "value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_ps_button, {
              class: "text-center w-60 mx-auto mt-8 py-4",
              onClick: $setup.isPhoneVerified
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("edit_profile__submit")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ps_loading_dialog, { ref: "ps_loading_dialog" }, null, 512),
    _createVNode(_component_user_phone_login_verification_modal, { ref: "user_phone_login_verification_modal" }, null, 512),
    _createVNode(_component_ps_error_dialog, { ref: "ps_error_dialog" }, null, 512)
  ], 64))
}